import(/* webpackMode: "eager", webpackExports: ["SearchScrollTopButtonClient"] */ "/builds/empiriecom/core/frontend/turborepo/apps/shopping/src/app/[lang]/(shop)/(search)/SearchScrollTopButton.client.tsx");
;
import(/* webpackMode: "eager" */ "/builds/empiriecom/core/frontend/turborepo/packages/shared/src/components/ErrorBoundary/ErrorBoundary.tsx");
